// source: witbooking/ari/v1/domain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.witbooking.ari.v1.BucketType', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.Codes', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.Devices', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.Devices.DeviceType', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.InvMaxOccupancyByType', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.InventoryAccommodation', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.InventoryAccommodationOccupancy', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.NillableBool', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.NillableDouble', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.NillableInt', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.TimeWindows', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.TimeWindows.TimeWindow', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.WeekDay', null, global);
goog.exportSymbol('proto.witbooking.ari.v1.WeekDays', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.TimeWindows = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.TimeWindows.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.TimeWindows, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.TimeWindows.displayName = 'proto.witbooking.ari.v1.TimeWindows';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.TimeWindows.TimeWindow.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.TimeWindows.TimeWindow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.TimeWindows.TimeWindow.displayName = 'proto.witbooking.ari.v1.TimeWindows.TimeWindow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.Codes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.Codes.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.Codes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.Codes.displayName = 'proto.witbooking.ari.v1.Codes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.WeekDays = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.WeekDays.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.WeekDays, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.WeekDays.displayName = 'proto.witbooking.ari.v1.WeekDays';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.Devices = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.Devices.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.Devices, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.Devices.displayName = 'proto.witbooking.ari.v1.Devices';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.NillableInt = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.NillableInt, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.NillableInt.displayName = 'proto.witbooking.ari.v1.NillableInt';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.NillableDouble = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.NillableDouble, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.NillableDouble.displayName = 'proto.witbooking.ari.v1.NillableDouble';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.NillableBool = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.NillableBool, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.NillableBool.displayName = 'proto.witbooking.ari.v1.NillableBool';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.InventoryAccommodation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.ari.v1.InventoryAccommodation.repeatedFields_, null);
};
goog.inherits(proto.witbooking.ari.v1.InventoryAccommodation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.InventoryAccommodation.displayName = 'proto.witbooking.ari.v1.InventoryAccommodation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.InventoryAccommodationOccupancy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.InventoryAccommodationOccupancy.displayName = 'proto.witbooking.ari.v1.InventoryAccommodationOccupancy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.ari.v1.InvMaxOccupancyByType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.ari.v1.InvMaxOccupancyByType.displayName = 'proto.witbooking.ari.v1.InvMaxOccupancyByType';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.TimeWindows.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.TimeWindows.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.TimeWindows.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.TimeWindows} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.TimeWindows.toObject = function(includeInstance, msg) {
  var f, obj = {
    windowsList: jspb.Message.toObjectList(msg.getWindowsList(),
    proto.witbooking.ari.v1.TimeWindows.TimeWindow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.TimeWindows}
 */
proto.witbooking.ari.v1.TimeWindows.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.TimeWindows;
  return proto.witbooking.ari.v1.TimeWindows.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.TimeWindows} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.TimeWindows}
 */
proto.witbooking.ari.v1.TimeWindows.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.ari.v1.TimeWindows.TimeWindow;
      reader.readMessage(value,proto.witbooking.ari.v1.TimeWindows.TimeWindow.deserializeBinaryFromReader);
      msg.addWindows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.TimeWindows.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.TimeWindows.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.TimeWindows} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.TimeWindows.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWindowsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.ari.v1.TimeWindows.TimeWindow.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.TimeWindows.TimeWindow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.toObject = function(includeInstance, msg) {
  var f, obj = {
    epochStartDay: jspb.Message.getFieldWithDefault(msg, 1, 0),
    epochEndDay: jspb.Message.getFieldWithDefault(msg, 2, 0),
    allowedDaysList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    allowedHoursList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow}
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.TimeWindows.TimeWindow;
  return proto.witbooking.ari.v1.TimeWindows.TimeWindow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow}
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEpochStartDay(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEpochEndDay(value);
      break;
    case 3:
      var value = /** @type {!Array<!proto.witbooking.ari.v1.WeekDay>} */ (reader.readPackedEnum());
      msg.setAllowedDaysList(value);
      break;
    case 4:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setAllowedHoursList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.TimeWindows.TimeWindow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEpochStartDay();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEpochEndDay();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAllowedDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getAllowedHoursList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
};


/**
 * optional int64 epoch_start_day = 1;
 * @return {number}
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.getEpochStartDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} returns this
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.setEpochStartDay = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 epoch_end_day = 2;
 * @return {number}
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.getEpochEndDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} returns this
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.setEpochEndDay = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated WeekDay allowed_days = 3;
 * @return {!Array<!proto.witbooking.ari.v1.WeekDay>}
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.getAllowedDaysList = function() {
  return /** @type {!Array<!proto.witbooking.ari.v1.WeekDay>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.WeekDay>} value
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} returns this
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.setAllowedDaysList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.witbooking.ari.v1.WeekDay} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} returns this
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.addAllowedDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} returns this
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.clearAllowedDaysList = function() {
  return this.setAllowedDaysList([]);
};


/**
 * repeated int32 allowed_hours = 4;
 * @return {!Array<number>}
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.getAllowedHoursList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} returns this
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.setAllowedHoursList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} returns this
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.addAllowedHours = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow} returns this
 */
proto.witbooking.ari.v1.TimeWindows.TimeWindow.prototype.clearAllowedHoursList = function() {
  return this.setAllowedHoursList([]);
};


/**
 * repeated TimeWindow windows = 1;
 * @return {!Array<!proto.witbooking.ari.v1.TimeWindows.TimeWindow>}
 */
proto.witbooking.ari.v1.TimeWindows.prototype.getWindowsList = function() {
  return /** @type{!Array<!proto.witbooking.ari.v1.TimeWindows.TimeWindow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.ari.v1.TimeWindows.TimeWindow, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.TimeWindows.TimeWindow>} value
 * @return {!proto.witbooking.ari.v1.TimeWindows} returns this
*/
proto.witbooking.ari.v1.TimeWindows.prototype.setWindowsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.ari.v1.TimeWindows.TimeWindow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.TimeWindows.TimeWindow}
 */
proto.witbooking.ari.v1.TimeWindows.prototype.addWindows = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.ari.v1.TimeWindows.TimeWindow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.TimeWindows} returns this
 */
proto.witbooking.ari.v1.TimeWindows.prototype.clearWindowsList = function() {
  return this.setWindowsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.Codes.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.Codes.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.Codes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.Codes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.Codes.toObject = function(includeInstance, msg) {
  var f, obj = {
    codeList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.Codes}
 */
proto.witbooking.ari.v1.Codes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.Codes;
  return proto.witbooking.ari.v1.Codes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.Codes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.Codes}
 */
proto.witbooking.ari.v1.Codes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.Codes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.Codes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.Codes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.Codes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCodeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string code = 1;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.Codes.prototype.getCodeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.Codes} returns this
 */
proto.witbooking.ari.v1.Codes.prototype.setCodeList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.Codes} returns this
 */
proto.witbooking.ari.v1.Codes.prototype.addCode = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.Codes} returns this
 */
proto.witbooking.ari.v1.Codes.prototype.clearCodeList = function() {
  return this.setCodeList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.WeekDays.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.WeekDays.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.WeekDays.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.WeekDays} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.WeekDays.toObject = function(includeInstance, msg) {
  var f, obj = {
    daysList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.WeekDays}
 */
proto.witbooking.ari.v1.WeekDays.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.WeekDays;
  return proto.witbooking.ari.v1.WeekDays.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.WeekDays} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.WeekDays}
 */
proto.witbooking.ari.v1.WeekDays.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<!proto.witbooking.ari.v1.WeekDay>} */ (reader.readPackedEnum());
      msg.setDaysList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.WeekDays.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.WeekDays.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.WeekDays} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.WeekDays.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDaysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated WeekDay days = 1;
 * @return {!Array<!proto.witbooking.ari.v1.WeekDay>}
 */
proto.witbooking.ari.v1.WeekDays.prototype.getDaysList = function() {
  return /** @type {!Array<!proto.witbooking.ari.v1.WeekDay>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.WeekDay>} value
 * @return {!proto.witbooking.ari.v1.WeekDays} returns this
 */
proto.witbooking.ari.v1.WeekDays.prototype.setDaysList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.witbooking.ari.v1.WeekDay} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.WeekDays} returns this
 */
proto.witbooking.ari.v1.WeekDays.prototype.addDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.WeekDays} returns this
 */
proto.witbooking.ari.v1.WeekDays.prototype.clearDaysList = function() {
  return this.setDaysList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.Devices.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.Devices.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.Devices.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.Devices} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.Devices.toObject = function(includeInstance, msg) {
  var f, obj = {
    allowedDevicesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.Devices}
 */
proto.witbooking.ari.v1.Devices.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.Devices;
  return proto.witbooking.ari.v1.Devices.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.Devices} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.Devices}
 */
proto.witbooking.ari.v1.Devices.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<!proto.witbooking.ari.v1.Devices.DeviceType>} */ (reader.readPackedEnum());
      msg.setAllowedDevicesList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.Devices.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.Devices.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.Devices} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.Devices.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowedDevicesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.witbooking.ari.v1.Devices.DeviceType = {
  DEVICE_TYPE_INVALID: 0,
  DEVICE_TYPE_DESKTOP: 1,
  DEVICE_TYPE_TABLET: 2,
  DEVICE_TYPE_MOBILE: 3
};

/**
 * repeated DeviceType allowed_devices = 1;
 * @return {!Array<!proto.witbooking.ari.v1.Devices.DeviceType>}
 */
proto.witbooking.ari.v1.Devices.prototype.getAllowedDevicesList = function() {
  return /** @type {!Array<!proto.witbooking.ari.v1.Devices.DeviceType>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.witbooking.ari.v1.Devices.DeviceType>} value
 * @return {!proto.witbooking.ari.v1.Devices} returns this
 */
proto.witbooking.ari.v1.Devices.prototype.setAllowedDevicesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.witbooking.ari.v1.Devices.DeviceType} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.Devices} returns this
 */
proto.witbooking.ari.v1.Devices.prototype.addAllowedDevices = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.Devices} returns this
 */
proto.witbooking.ari.v1.Devices.prototype.clearAllowedDevicesList = function() {
  return this.setAllowedDevicesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.NillableInt.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.NillableInt.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.NillableInt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.NillableInt.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.NillableInt}
 */
proto.witbooking.ari.v1.NillableInt.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.NillableInt;
  return proto.witbooking.ari.v1.NillableInt.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.NillableInt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.NillableInt}
 */
proto.witbooking.ari.v1.NillableInt.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.NillableInt.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.NillableInt.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.NillableInt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.NillableInt.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 value = 1;
 * @return {number}
 */
proto.witbooking.ari.v1.NillableInt.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.NillableInt} returns this
 */
proto.witbooking.ari.v1.NillableInt.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.NillableDouble.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.NillableDouble.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.NillableDouble} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.NillableDouble.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.NillableDouble}
 */
proto.witbooking.ari.v1.NillableDouble.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.NillableDouble;
  return proto.witbooking.ari.v1.NillableDouble.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.NillableDouble} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.NillableDouble}
 */
proto.witbooking.ari.v1.NillableDouble.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.NillableDouble.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.NillableDouble.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.NillableDouble} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.NillableDouble.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.witbooking.ari.v1.NillableDouble.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.NillableDouble} returns this
 */
proto.witbooking.ari.v1.NillableDouble.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.NillableBool.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.NillableBool.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.NillableBool} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.NillableBool.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.NillableBool}
 */
proto.witbooking.ari.v1.NillableBool.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.NillableBool;
  return proto.witbooking.ari.v1.NillableBool.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.NillableBool} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.NillableBool}
 */
proto.witbooking.ari.v1.NillableBool.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.NillableBool.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.NillableBool.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.NillableBool} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.NillableBool.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.witbooking.ari.v1.NillableBool.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.ari.v1.NillableBool} returns this
 */
proto.witbooking.ari.v1.NillableBool.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.ari.v1.InventoryAccommodation.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.InventoryAccommodation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.InventoryAccommodation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.InventoryAccommodation.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    occupancy: (f = msg.getOccupancy()) && proto.witbooking.ari.v1.InventoryAccommodationOccupancy.toObject(includeInstance, f),
    occupancyCombinationsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    accommodationBaseAdults: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation}
 */
proto.witbooking.ari.v1.InventoryAccommodation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.InventoryAccommodation;
  return proto.witbooking.ari.v1.InventoryAccommodation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.InventoryAccommodation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation}
 */
proto.witbooking.ari.v1.InventoryAccommodation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 7:
      var value = new proto.witbooking.ari.v1.InventoryAccommodationOccupancy;
      reader.readMessage(value,proto.witbooking.ari.v1.InventoryAccommodationOccupancy.deserializeBinaryFromReader);
      msg.setOccupancy(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addOccupancyCombinations(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccommodationBaseAdults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.InventoryAccommodation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.InventoryAccommodation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.InventoryAccommodation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOccupancy();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.witbooking.ari.v1.InventoryAccommodationOccupancy.serializeBinaryToWriter
    );
  }
  f = message.getOccupancyCombinationsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getAccommodationBaseAdults();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation} returns this
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional InventoryAccommodationOccupancy occupancy = 7;
 * @return {?proto.witbooking.ari.v1.InventoryAccommodationOccupancy}
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.getOccupancy = function() {
  return /** @type{?proto.witbooking.ari.v1.InventoryAccommodationOccupancy} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.InventoryAccommodationOccupancy, 7));
};


/**
 * @param {?proto.witbooking.ari.v1.InventoryAccommodationOccupancy|undefined} value
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation} returns this
*/
proto.witbooking.ari.v1.InventoryAccommodation.prototype.setOccupancy = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation} returns this
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.clearOccupancy = function() {
  return this.setOccupancy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.hasOccupancy = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated string occupancy_combinations = 8;
 * @return {!Array<string>}
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.getOccupancyCombinationsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation} returns this
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.setOccupancyCombinationsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation} returns this
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.addOccupancyCombinations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation} returns this
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.clearOccupancyCombinationsList = function() {
  return this.setOccupancyCombinationsList([]);
};


/**
 * optional int32 accommodation_base_adults = 9;
 * @return {number}
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.getAccommodationBaseAdults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.InventoryAccommodation} returns this
 */
proto.witbooking.ari.v1.InventoryAccommodation.prototype.setAccommodationBaseAdults = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.InventoryAccommodationOccupancy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.InventoryAccommodationOccupancy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.toObject = function(includeInstance, msg) {
  var f, obj = {
    maxOccupancy: jspb.Message.getFieldWithDefault(msg, 1, 0),
    maxOccupancyByType: (f = msg.getMaxOccupancyByType()) && proto.witbooking.ari.v1.InvMaxOccupancyByType.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.InventoryAccommodationOccupancy}
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.InventoryAccommodationOccupancy;
  return proto.witbooking.ari.v1.InventoryAccommodationOccupancy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.InventoryAccommodationOccupancy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.InventoryAccommodationOccupancy}
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxOccupancy(value);
      break;
    case 2:
      var value = new proto.witbooking.ari.v1.InvMaxOccupancyByType;
      reader.readMessage(value,proto.witbooking.ari.v1.InvMaxOccupancyByType.deserializeBinaryFromReader);
      msg.setMaxOccupancyByType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.InventoryAccommodationOccupancy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.InventoryAccommodationOccupancy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMaxOccupancy();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMaxOccupancyByType();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.ari.v1.InvMaxOccupancyByType.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 max_occupancy = 1;
 * @return {number}
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.prototype.getMaxOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.InventoryAccommodationOccupancy} returns this
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.prototype.setMaxOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional InvMaxOccupancyByType max_occupancy_by_type = 2;
 * @return {?proto.witbooking.ari.v1.InvMaxOccupancyByType}
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.prototype.getMaxOccupancyByType = function() {
  return /** @type{?proto.witbooking.ari.v1.InvMaxOccupancyByType} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.ari.v1.InvMaxOccupancyByType, 2));
};


/**
 * @param {?proto.witbooking.ari.v1.InvMaxOccupancyByType|undefined} value
 * @return {!proto.witbooking.ari.v1.InventoryAccommodationOccupancy} returns this
*/
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.prototype.setMaxOccupancyByType = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.ari.v1.InventoryAccommodationOccupancy} returns this
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.prototype.clearMaxOccupancyByType = function() {
  return this.setMaxOccupancyByType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.ari.v1.InventoryAccommodationOccupancy.prototype.hasMaxOccupancyByType = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.ari.v1.InvMaxOccupancyByType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.ari.v1.InvMaxOccupancyByType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.toObject = function(includeInstance, msg) {
  var f, obj = {
    senior: jspb.Message.getFieldWithDefault(msg, 1, 0),
    adults: jspb.Message.getFieldWithDefault(msg, 2, 0),
    juniors: jspb.Message.getFieldWithDefault(msg, 3, 0),
    children: jspb.Message.getFieldWithDefault(msg, 4, 0),
    babies: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.ari.v1.InvMaxOccupancyByType}
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.ari.v1.InvMaxOccupancyByType;
  return proto.witbooking.ari.v1.InvMaxOccupancyByType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.ari.v1.InvMaxOccupancyByType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.ari.v1.InvMaxOccupancyByType}
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSenior(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdults(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setJuniors(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChildren(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBabies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.ari.v1.InvMaxOccupancyByType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.ari.v1.InvMaxOccupancyByType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSenior();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAdults();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getJuniors();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getChildren();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getBabies();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 senior = 1;
 * @return {number}
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.getSenior = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.InvMaxOccupancyByType} returns this
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.setSenior = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 adults = 2;
 * @return {number}
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.getAdults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.InvMaxOccupancyByType} returns this
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.setAdults = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 juniors = 3;
 * @return {number}
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.getJuniors = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.InvMaxOccupancyByType} returns this
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.setJuniors = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 children = 4;
 * @return {number}
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.getChildren = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.InvMaxOccupancyByType} returns this
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.setChildren = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 babies = 5;
 * @return {number}
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.getBabies = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.ari.v1.InvMaxOccupancyByType} returns this
 */
proto.witbooking.ari.v1.InvMaxOccupancyByType.prototype.setBabies = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.witbooking.ari.v1.WeekDay = {
  WEEKDAY_INVALID: 0,
  WEEKDAY_MONDAY: 1,
  WEEKDAY_TUESDAY: 2,
  WEEKDAY_WEDNESDAY: 3,
  WEEKDAY_THURSDAY: 4,
  WEEKDAY_FRIDAY: 5,
  WEEKDAY_SATURDAY: 6,
  WEEKDAY_SUNDAY: 7
};

/**
 * @enum {number}
 */
proto.witbooking.ari.v1.BucketType = {
  BUCKET_TYPE_INVALID: 0,
  BUCKET_TYPE_INVENTORY: 1,
  BUCKET_TYPE_DISCOUNT: 2,
  BUCKET_TYPE_EXTRA: 3,
  BUCKET_TYPE_COMPLEMENTS: 4,
  BUCKET_TYPE_BUNDLES: 5
};

goog.object.extend(exports, proto.witbooking.ari.v1);
